import { EDeviceType, IDevices } from './IEnumerateDevices';

const filterDevicesByKind: (
  devices: MediaDeviceInfo[],
  kind: MediaDeviceKind,
) => MediaDeviceInfo[] = (devices, kind) => devices.filter((device) => device.kind === kind);

export const enumerateDevices: () => Promise<IDevices> = async () => {
  const devices: MediaDeviceInfo[] = await navigator.mediaDevices.enumerateDevices();

  return {
    audioInputs: filterDevicesByKind(devices, EDeviceType.AUDIO_INPUT),
    audioOutputs: filterDevicesByKind(devices, EDeviceType.AUDIO_OUTPUT),
    videoInputs: filterDevicesByKind(devices, EDeviceType.VIDEO_INPUT),
  };
};
